import { render, staticRenderFns } from "./StockTransferWarehouse.vue?vue&type=template&id=6d5bb146&scoped=true&"
import script from "./StockTransferWarehouse.vue?vue&type=script&lang=js&"
export * from "./StockTransferWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./StockTransferWarehouse.vue?vue&type=style&index=0&id=6d5bb146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5bb146",
  null
  
)

export default component.exports